import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { toDataSourceRequestString } from '@progress/kendo-data-query';
import { Observable } from 'rxjs';
import { GridState } from '@shared';
@Injectable()
export class CategoryService {
  private apiUrl: string = environment.apiUrl + '/categories';
  constructor(private httpClient: HttpClient) {}

  getCategories(
    restaurantId: string,
    productType: string,
  ): Observable<GridDataResult> {
    let state = {
      filter: {
        logic: 'and',
        filters: [{ field: 'isActive', operator: 'eq', value: true }],
      },
      sort: [{ field: 'sortOrder', dir: 'asc' }],
    } as GridState;

    return this.httpClient.get<GridDataResult>(
      `${this.apiUrl}/${productType}?restaurantId=${restaurantId}&${toDataSourceRequestString(state)}`,
    );
  }

  getAllCategories(state: GridState): Observable<GridDataResult> {
    return this.httpClient.get<GridDataResult>(
      `${this.apiUrl}?${toDataSourceRequestString(state)}`,
    );
  }
}
